export default __webpack_public_path__ + "static/Aix_En_Provence_Provence_France-e3527f163d9bd41f41a334abb6b65bf5.jpg";